import { useState } from "react"
import { toast } from "sonner"
import { OffsetDateTime } from "@js-joda/core"
import BackButton from "@/components/BackButton"
import { Button } from "@/components/chadcn/Button"
import DateTimePicker from "@/screens/measurements/components/DateTimePicker"
import FoodLogInfoModal from "@/screens/measurements/components/FoodLogInfoModal"
import { nowIso } from "@/util/date-utils"

const HEADING = "When did you eat?"
const SUBMIT_BUTTON = "Continue"

type Props = {
  dateTime: string | null
  onChangeDateTime: (value: string) => void
  onBack?: () => void
}

const FoodLogDateTimePickerStep = ({ dateTime, onChangeDateTime, onBack }: Props) => {
  const [value, setValue] = useState<string>(dateTime ?? nowIso())
  const [infoOpen, setInfoOpen] = useState(false)

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const parsed = OffsetDateTime.parse(value)
    if (parsed.isAfter(OffsetDateTime.now(parsed.offset()))) {
      toast.warning("The date and time you select must not be in the future.")
      return
    }
    onChangeDateTime(value)
  }

  return (
    <form className="flex min-h-[calc(100vh-32px)] flex-col gap-4" onSubmit={handleSubmit}>
      {onBack && <BackButton customClickHandler={onBack} />}
      <h2 className="text-h2 text-primary-contrast">{HEADING}</h2>
      <div className="mt-6 flex flex-1 flex-col gap-4">
        <DateTimePicker value={value} onChange={setValue} />
        <div className="flex justify-end">
          <button
            type="button"
            onClick={() => setInfoOpen(true)}
            className="text-sm font-medium text-primary-contrast underline"
          >
            Why is tracking food important?
          </button>
        </div>
      </div>
      <Button type="submit" className="w-full py-2 text-base">
        {SUBMIT_BUTTON}
      </Button>
      <FoodLogInfoModal open={infoOpen} onClose={() => setInfoOpen(false)} />
    </form>
  )
}

export default FoodLogDateTimePickerStep
